<template>
  <div class="recipeIndex">
    <div style="text-align: center;display:flex;align-items: center;width: 100%;"
         :style="{'height': loaderHeight + 'px'}" v-show="isLoading">
      <div style="margin:0 auto">
        <img width="100px" src="static/loader-gif.gif" class="rounded"/>
        <br/>
        {{ $t('message.loadingText') }}
      </div>
    </div>
    <recipe-search-header v-show="!isLoading" :class="{
       'isBreakfast': isBreakfast,
       'isLunch': isLunch,
       'isDinner': isDinner,
       'isNight': isNight
    }"></recipe-search-header>
    <div class="paddingMobile">
      <div class="recipesContainer">
        <div class="seasonalRecipes">
          <horizontal-scroller
            v-if="isChristmas && seasonal.christmas.length > 0"
            title="Merry Christmas! Here are this years best picks"
            :recipes="seasonal.christmas"
            grouping-type="occasions"
            grouping-route="christmas"
          >
          </horizontal-scroller>
          <horizontal-scroller
            v-if="isThanksGiving && seasonal.thanksgiving.length > 0"
            title="Happy Thanksgiving!"
            :recipes="seasonal.thanksgiving"
            grouping-type="occasions"
            grouping-route="thanksgiving"
          >
          </horizontal-scroller>
          <horizontal-scroller
            v-if="isEaster && seasonal.easter.length > 0"
            title="Happy Easter!"
            :recipes="seasonal.easter"
            grouping-type="occasions"
            grouping-route="easter"
          >
          </horizontal-scroller>
          <horizontal-scroller
            v-if="isHalloween && seasonal.halloween.length > 0"
            title="Happy Halloween!"
            :recipes="seasonal.easter"
            grouping-type="occasions"
            grouping-route="halloween"
          >
          </horizontal-scroller>
          <horizontal-scroller
            v-if="isDiwali && seasonal.diwali.length > 0"
            title="Happy Diwali!"
            :recipes="seasonal.diwali"
            grouping-type="occasions"
            grouping-route="diwali"
          >
          </horizontal-scroller>
        </div>
        <div class="timelyRecipes">
          <div v-if="timely.recipes.length > 0">
            <div v-if="isBreakfast">
              <horizontal-scroller
                title="Browse today's breakfast recipes"
                v-if="timely.recipes.length > 0"
                groupingType="categories"
                groupingRoute="breakfast"
                :recipes="timely.recipes"></horizontal-scroller>
            </div>
            <div v-if="isLunch">
              <horizontal-scroller
                title="Browse today's lunch recipes"
                v-if="timely.recipes.length > 0"
                groupingType="categories"
                groupingRoute="lunch"
                :recipes="timely.recipes"></horizontal-scroller>
            </div>
            <div v-if="isDinner">
              <horizontal-scroller
                title="Browse this evening's dinner recipes"
                v-if="timely.recipes.length > 0"
                groupingType="categories"
                groupingRoute="dinner"
                :recipes="timely.recipes"></horizontal-scroller>
            </div>

            <div v-if="isNight">
              <horizontal-scroller
                title="Get ready for tomorrow morning's breakfast"
                v-if="timely.recipes.length > 0"
                groupingType="categories"
                groupingRoute="breakfast"
                :recipes="timely.recipes">
              </horizontal-scroller>
            </div>
          </div>
        </div>
        <horizontal-scroller
          v-if="allergiesExcluded.recipes.length > 0"
          linkTo="dietaryTypes"
          grouping-type="allergies"
          :grouping-route="allergyCsv"
          title="Based on your allergies"
          :recipes="allergiesExcluded.recipes">
        </horizontal-scroller>
        <horizontal-scroller
          v-if="favoriteBased.recipes.length > 0"
          title="Based on your favourites"
          groupingType="favourites"
          :groupingRoute="favoriteFoodsCsv"
          :recipes="favoriteBased.recipes"></horizontal-scroller>
        <!--
        <div class="seasonalRecipes bottom" v-if="seasonal.recipes.length > 0">
          <div>
            <h2 v-if="isEaster">Our picks for this Easter Sunday</h2>
            <h2 v-if="isChristmas">Merry Christmas, {{$store.state.user.scope.firstname}}!</h2>
            <h2 v-if="isThanksGiving">Happy Thanksgiving, {{$store.state.user.scope.firstname}}!</h2>
            <mu-row gutter>
              <mu-col class="bottom" v-for="item, seasonalI in seasonal.recipes" :key="'recipe-seasonal-' + seasonalI"
                      width="100"
                      desktop="33" tablet="33">
                <recipe-card :recipe="item"></recipe-card>
              </mu-col>
            </mu-row>
          </div>
        </div>
        -->
        <mu-row gutter class="dietaryTypes">
          <mu-col width="100" desktop="100" tablet="100" v-for="item, dtIndex in dietaryTypes.recipes"
                  :key="'dt-index-' + dtIndex" v-if="item.recipes.length > 3">
            <horizontal-scroller
              :title="item.grouping"
              groupingType="dietaryTypes"
              :grouping-route="item.grouping"
              :recipes="item.recipes">
            </horizontal-scroller>
          </mu-col>
        </mu-row>




        <div ref="scroll-detector" v-if="!cuisines.recipes.length > 0"></div>

        <div style="text-align: center">
          <mu-circular-progress v-show="isAppending" :size="32"></mu-circular-progress>
        </div>


        <mu-row gutter class="cuisines">
          <mu-col width="100" desktop="100" tablet="100" v-for="item, cIndex in cuisines.recipes"
                  :key="'c-index-' + cIndex" v-if="item.recipes.length > 3">
            <horizontal-scroller
              :title="item.grouping"
              groupingType="cuisines"
              :grouping-route="item.grouping"
              :recipes="item.recipes">
            </horizontal-scroller>
          </mu-col>
        </mu-row>

      </div>
    </div>
  </div>
</template>

<script>
import AccountApi from '../../api/Account';
import RecipeApi from '../../api/Recipes'
import RecipeCard from "./Components/RecipeCard";
import moment from 'moment'
import RecipeSearchHeader from "./Components/RecipeSearchHeader";
import UserApi from '../../api/User'
import TimingsMixin from './Mixins/Timings'
import HorizontalScroller from "./Components/HorizontalScroller";
import ScrollManager from "../../helpers/ScrollManager";

export default {
  components: {
    HorizontalScroller,
    RecipeSearchHeader,
    RecipeCard
  },
  mixins: [TimingsMixin],
  name: "recipes-index",
  data() {
    return {
      scroller: document.getElementsByClassName('main-content')[0],
      dietaryPreferenceId: 0,
      loaderHeight: 0,
      isLoading: true,
      isAppending: false,
      lists: {},
      recipeLimit: 15,
      timely: {
        recipes: []
      },
      seasonal: {
        christmas: [],
        easter: [],
        thanksgiving: [],
        halloween: [],
        diwali: []
      },
      cuisines: {
        recipes: []
      },
      allergiesExcluded: {
        recipes: []
      },
      dietaryTypes: {
        recipes: []
      },
      favoriteBased: {
        recipes: []
      },
      favorites: [],
      favoriteFoodsCsv: "",
      allergyCsv: ""
    }
  },
  watch: {
    isLoading: function () {
      if (this.isLoading === false) {
        $('.main-content').attr('style', 'overflow-y: scroll')
      }
    },
    '$route': {
      immediate: true,
      handler: function () {
        this.init();
      }
    }
  },
  mounted() {
    let element = document.getElementsByClassName('main-content')[0];
    element.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (ScrollManager.isElementInViewport(this.$refs['scroll-detector'])) {
        if (this.isAppending === false) {
          this.loadCuisines();
        }
      }
    },
    init() {
      let self = this;
      self.lists = self.$store.state.list;

      $('.main-content').attr('style', 'overflow-y: hidden')

      const loaderHeight = $('.main-content').outerHeight();
      self.loaderHeight = loaderHeight;

      let allergies = self.lists.allergies;

      const loadAll = () => {
        UserApi.getFavouriteFoods()
          .then(function (response) {
            let foods = [];
            for (let i = 0; i < response.data.length; i++) {
              foods.push(response.data[i].food_name);
            }
            self.favorites = foods;

            let favoriteFoodsAsString = self.favorites.join(' ');
            self.favoriteFoodsCsv = favoriteFoodsAsString;

            RecipeApi.search({
              page: 0,
              limit: self.recipeLimit,
              dietaryTypes: self.dietaryTypesList().join(','),
              suitabilities: self.allergyCsv,
              favorite: true,
              search: favoriteFoodsAsString,
              shuffle: true
            })
              .then(function (response) {
                self.favoriteBased = response.data;

                self.loadTimely().then(function () {
                  if (self.isDiwali === true) {
                    RecipeApi.search({
                      page: 0,
                      limit: self.recipeLimit,
                      occasions: 'diwali',
                      suitabilities: self.allergyCsv,
                      dietaryTypes: self.dietaryTypesList().join(','),
                      shuffle: true
                    })
                      .then(function (response) {
                        self.seasonal.diwali = response.data.recipes;
                      })
                  }

                  if (self.isEaster === true) {
                    RecipeApi.search({
                      page: 0,
                      limit: self.recipeLimit,
                      occasions: 'easter',
                      dietaryTypes: self.dietaryTypesList().join(','),
                      suitabilities: self.allergyCsv,
                      shuffle: true
                    })
                      .then(function (response) {
                        self.seasonal.easter = response.data.recipes;
                      })
                  }

                  if (self.isChristmas === true) {
                    RecipeApi.search({
                      page: 0,
                      limit: self.recipeLimit,
                      occasions: 'christmas',
                      dietaryTypes: self.dietaryTypesList().join(','),
                      shuffle: true
                    })
                      .then(function (response) {
                        self.seasonal.christmas = response.data.recipes;
                      })
                  }

                  if (self.isThanksGiving) {
                    RecipeApi.search({
                      occasions: 'thanksgiving',
                      page: 0,
                      limit: self.recipeLimit,
                      dietaryTypes: self.dietaryTypesList().join(','),
                      suitabilities: self.allergyCsv,
                      shuffle: true
                    })
                      .then(function (response) {
                        self.seasonal.thanksgiving = response.data.recipes;
                      })
                  }

                  if (self.isHalloween) {
                    RecipeApi.search({
                      occasions: 'halloween',
                      page: 0,
                      limit: self.recipeLimit,
                      dietaryTypes: self.dietaryTypesList().join(','),
                      suitabilities: self.allergyCsv,
                      shuffle: true
                    })
                      .then(function (response) {
                        self.seasonal.halloween = response.data.recipes;
                      })
                  }

                  self.loadDietaryTypes();
                });
              })
          });
      }

      AccountApi.getUserPersonalization()
        .then(function (response) {
          self.dietaryPreferenceId = response.data.dietry_preference_id;
          let allergyStrings = [];
          if (response.data.allergies.length === 0) {
            loadAll();
          } else {
            for (let i = 0; i < response.data.allergies.length; i++) {
              let foundAllergy = allergies.filter(function (item) {
                return item.allergy_id === response.data.allergies[i];
              });

              if (foundAllergy.length > 0) {
                allergyStrings.push(foundAllergy[0].name);
              }
            }

            self.allergyCsv = allergyStrings.join(',');

            RecipeApi.search(
              {
                page: 0,
                limit: self.recipeLimit,
                suitabilities: allergyStrings.join(','),
                dietaryTypes: self.dietaryTypesList().join(','),
                shuffle: true
              })
              .then(function (response) {
                self.allergiesExcluded.recipes = response.data.recipes;

                self.$nextTick(function () {
                  loadAll();
                })
              });
          }
        })
    },
    cuisinesList() {
      return [
        "African",
        "American",
        "British",
        "Caribbean",
        "Chinese",
        "French",
        "Greek",
        "Iberian",
        "Indian",
        "Irish",
        "Italian",
        "Japanese",
        "Mediterranean",
        "Mexican",
        "Moroccan",
        "Nordic",
        "Portuguese",
        "South",
        "American",
        "Spanish",
        "Thai",
        "Turkish",
        "Vietnamese"
      ]
    },
    loadCuisines() {
      let self = this;
      self.isAppending = true;
      RecipeApi.group({
        'limit': self.recipeLimit,
        'type': 'cuisines',
        'cuisines': self.cuisinesList().join(','),
        'filterSuitabilities': self.allergyCsv,
        'dietaryTypes': self.dietaryTypesList().join(','),
        'shuffle': true
      })
        .then(function (response) {
          self.isAppending = false;
          self.$forceUpdate();
          self.$nextTick(() => {
            self.cuisines.recipes = response.data.recipes;
          })
        })
    },
    dietaryTypesList() {
      let self = this;
      switch (self.dietaryPreferenceId) {
        case 1:
          return [
            'Gluten-free',
            'Iron rich',
            'Ketogenic',
            'Low GI',
            'Organic',
            'Paleolithic',
            'Pescetarian',
            'Raw Foods',
            'Vegan',
            'Vegetarian'
          ];
        case 2:
          return [
            'Pescetarian'
          ];
        case 3:
          return [
            'Vegetarian'
          ];
        case 4:
          return [
            'Vegan'
          ];
        default:
          return [
            'Gluten-free',
            'Iron rich',
            'Ketogenic',
            'Low GI',
            'Organic',
            'Paleolithic',
            'Pescetarian',
            'Raw Foods',
            'Vegan',
            'Vegetarian'
          ];
      }
    },
    loadDietaryTypes() {
      let self = this;
      RecipeApi.group({
        'type': 'dietaryTypes',
        'dietaryTypes': self.dietaryTypesList().join(','),
        'filterSuitabilities': self.allergyCsv,
        'page': 0,
        'limit': self.recipeLimit,
        'shuffle': true
      })
        .then(function (response) {
          self.dietaryTypes = response.data;
          self.isLoading = false;
          //self.loadCuisines();
        });
    },
    loadTimely() {
      let self = this;
      return new Promise(function (resolve, reject) {
        if (self.isBreakfast) {
          RecipeApi.search({
            page: 0,
            limit: self.recipeLimit,
            categories: 'breakfast',
            dietaryTypes: self.dietaryTypesList().join(','),
            suitabilities: self.allergyCsv,
            shuffle: true
          })
            .then(function (response) {
              self.timely = response.data;
              resolve();
            })
            .catch(function () {
              reject();
            })
        }
        if (self.isLunch) {
          RecipeApi.search({
            page: 0,
            limit: self.recipeLimit,
            categories: 'lunch',
            suitabilities: self.allergyCsv,
            dietaryTypes: self.dietaryTypesList().join(','),
            shuffle: true

          })
            .then(function (response) {
              self.timely = response.data;
              resolve();
            })
            .catch(function () {
              reject();
            })

        }
        if (self.isDinner) {
          RecipeApi.search({
            page: 0,
            limit: self.recipeLimit,
            categories: 'dinner',
            suitabilities: self.allergyCsv,
            dietaryTypes: self.dietaryTypesList().join(','),
            shuffle: true
          })
            .then(function (response) {
              self.timely = response.data;
              resolve();
            })
            .catch(function () {
              reject();
            })

        }
        if (self.isNight) {
          RecipeApi.search({
            page: 0,
            limit: self.recipeLimit,
            categories: 'breakfast',
            suitabilities: self.allergyCsv,
            dietaryTypes: self.dietaryTypesList().join(','),
            shuffle: true
          })
            .then(function (response) {
              self.timely = response.data;
              resolve();
            })
            .catch(function () {
              reject();
            })
        }
      });
    }
  },
  beforeDestroy() {
    $('.main-content').attr('style', '')
  }
}
</script>
<style>


.owl-carousel .owl-stage-outer {
  position: relative;
  padding-left: 16px;
  overflow: hidden;
  -webkit-transform: translateZ(0);
}

#recipes {
  background: white;
}

.recipesContainer {
  padding-top: 24px;
}

@media (max-width: 800px) {
  .paddingMobile {
    padding-left: 0px;
    padding-right: 0px;
  }
}

div#recipes {
  padding-top: 0;
  margin-top: -65px;
  padding-left: 0;
  padding-right: 0;
  height: calc(100% + 50px)
}
</style>
<style lang="less">
.recipeIndex {
  h2 {
    color: #0179d5
  }
}
</style>



// WEBPACK FOOTER //
// Index.vue?f49d3606